

































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import IProductViewModel from '../models/IProductViewModel';
import IPriceEstimateProductViewModel from '../models/IPriceEstimateProductViewModel';

@Component({
    components: {
        
    }
})
export default class BookingProductListItem extends Vue {
    
    $t: any;

    @Prop({required: true})
    product: IPriceEstimateProductViewModel;

    @Prop({default: true})
    showPrice: boolean;

    @Prop({default: true})
    selectable: boolean;

    @Prop({default: false})
    selected: boolean;

    @Prop({default: false})
    deselectable: boolean;

    onSelectProductClick() {
      if (this.selectable){
        this.$emit("select", this.product);
      }
    }

    onDeselectProductClick() {
      if (this.deselectable){
        this.$emit("deselect", this.product);
      }
    }
}
